import { Link } from "react-router-dom";

const COLS = [
  ["Explore", [["/jobs", "Jobs"], ["/freelancing", "Freelancing"], ["/government", "Government Opportunities"], ["/community", "Community"], ["/community/directory", "Professional directory"]]],
  ["OpenPath", [["/about", "About OpenPath"], ["/employers", "For Employers"], ["/professionals", "For Professionals & Mentors"], ["/accessibility", "Accessibility"]]],
  ["Support", [["/help", "Help Centre & FAQs"], ["/contact", "Contact us"], ["/guidelines", "Community Guidelines"]]],
  ["Legal", [["/privacy", "Privacy Policy"], ["/terms", "Terms and Conditions"]]],
];

export default function Footer() {
  return (
    <footer className="on-dark mt-20 bg-navy text-white" data-testid="site-footer">
      <div className="container-x grid gap-10 py-14 md:grid-cols-2 xl:grid-cols-[minmax(0,1.55fr)_repeat(4,minmax(0,1fr))] xl:gap-12">
        <div className="max-w-sm">
          <div className="flex items-center gap-3" data-testid="footer-brand-lockup">
            <img
              src="/openpath-logo.png"
              alt="OpenPath"
              className="h-11 w-11 shrink-0 object-contain"
            />
            <p className="text-2xl font-extrabold">OpenPath</p>
          </div>
          <p className="mt-4 text-lg font-semibold text-white">
            Every Ability. More Possibilities.
          </p>
          <p className="mt-3 text-white/85">
            Jobs, freelance work, government opportunities and professional connections — built to be
            accessible for everyone.
          </p>
        </div>
        {COLS.map(([title, links]) => (
          <nav key={title} aria-label={`${title} links`}>
            <h2 className="text-base font-bold text-white">{title}</h2>
            <ul className="mt-3 space-y-1">
              {links.map(([to, l]) => <li key={to}><Link to={to} className="inline-flex min-h-[44px] items-center text-white/90 underline-offset-4 hover:underline" data-testid={`footer-link-${to.slice(1).replace("/", "-")}`}>{l}</Link></li>)}
            </ul>
          </nav>
        ))}
      </div>
      <div className="border-t border-white/20">
        <div className="container-x flex flex-col gap-3 py-6 text-sm text-white/85 md:flex-row md:items-center md:justify-between">
          <p>© 2026 OpenPath. All rights reserved.</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <p>Powered by Groundwork Co.</p>
            <p>Press Alt + Shift + A to open accessibility settings.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
